import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../../../helpers/custom-prop-types';
const ProfessionalUnitCompanyInformationAddress = (props) => {
    const { address, zipCode } = props;
    return (_jsxs("dl", Object.assign({ className: 'information_row' }, { children: [_jsx("dt", Object.assign({ className: 'information_label' }, { children: "\u4F4F\u6240" })), _jsxs("dd", Object.assign({ className: 'information_value' }, { children: [_jsx("span", { children: zipCode }), address && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("span", { children: address })] }))] }))] })));
};
ProfessionalUnitCompanyInformationAddress.propTypes = {
    address: propStr().isRequired,
    zipCode: propStr().isRequired,
};
export default ProfessionalUnitCompanyInformationAddress;
